import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { Button } from "../components/ui/button";
import { AuthShell, AuthHeading, AuthField, AuthAlert } from "../components/AuthShell";
import { api, formatApiError } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setDone(data.message);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell>
      {done ? (
        <div className="space-y-6" data-testid="forgot-success">
          <MailCheck className="h-10 w-10 text-emerald-400" />
          <AuthHeading title="Check your email" subtitle={done} />
          <p className="text-sm text-slate-400">The link expires in 1 hour. Check your spam folder if you don't see it.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-8" data-testid="forgot-form">
          <AuthHeading title="Forgot password" subtitle="Enter your account email and we'll send you a link to set a new password." />
          <div className="space-y-4">
            <AuthField id="email" label="Email" type="email" autoComplete="email" value={email} onChange={setEmail} testid="forgot-email-input" />
            {error && <AuthAlert testid="forgot-error">{error}</AuthAlert>}
          </div>
          <Button type="submit" disabled={busy} className="h-11 w-full bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold" data-testid="forgot-submit-button">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Send reset link
          </Button>
        </form>
      )}
      <p className="text-sm text-slate-400">
        <Link to="/login" className="text-amber-400 hover:underline font-medium" data-testid="forgot-back-link">← Back to sign in</Link>
      </p>
    </AuthShell>
  );
}
